<template>
    <MainContainer>
        <template v-slot:sidebar>&nbsp;</template>
        <div class="mv-probentypen">
            <h2>
                Probentypen
                <b-button
                    v-if="checkRight('write')"
                    :size="size"
                    @click="dataCreate"
                >
                    Neu
                    <font-awesome-icon icon="plus" />
                </b-button>
            </h2>
            <Table
                bordered
                striped
                small
                :fields="fields"
                :items="items"
                :isBusy="busy"
                :showFilter="true"
                sortBy="sort"
                busyText="Lädt Probenplan..."
                emptyText="Keine Informationen zum Probenplan gefunden"
            >
                <template v-slot:thead-top>
                    <template v-if="resorted">
                        <b-tr>
                            <b-td :colspan="fields.length" variant="warning">
                                Es wurden Änderungen an der Sortierung
                                vorgenommen, sollen diese gespeichert werden?
                                <b-button
                                    variant="primary"
                                    size="sm"
                                    :disabled="resortedBusy"
                                    @click="sortingProvide"
                                >
                                    <template v-if="resortedBusy">
                                        <Spinner small variant="light" />
                                    </template>
                                    <template v-else>Speichern</template>
                                </b-button>
                                <b-button
                                    variant="secondary"
                                    size="sm"
                                    class="ml-1"
                                    :disabled="resortedBusy"
                                    @click="sortingAbort"
                                >
                                    Abbrechen
                                </b-button>
                            </b-td>
                        </b-tr>
                    </template>
                </template>

                <template v-slot:kuerzel="{ row: row }">{{
                    row.value
                }}</template>

                <template v-slot:klasse="{ row: row }">
                    {{ klassen[row.value] }}
                </template>

                <template v-slot:sort="{ row: row }">
                    <b-button variant="link" @click="sortUp(row)">
                        <font-awesome-icon icon="chevron-up" />
                    </b-button>
                    <b-button variant="link" @click="sortDown(row)">
                        <font-awesome-icon icon="chevron-down" />
                    </b-button>
                </template>

                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="row.id && checkRight('write')"
                        :size="size"
                        @click="dataSelected(row)"
                        variant="link"
                        class="mv-table-action-btn mr-1"
                        >Bearbeiten</b-button
                    >
                    <b-button
                        v-if="row.id && checkRight('delete')"
                        :size="size"
                        @click="dataDelete(row)"
                        variant="link"
                        :disabled="true"
                        class="text-danger mv-table-action-btn"
                        >Löschen</b-button
                    >
                </template>
            </Table>
            <!-- Info modal -->
            <b-modal
                id="editModal"
                ref="editModal"
                :title="selected.title"
                size="lg"
                ok-title="Speichern"
                cancel-title="Abbrechen"
                :busy="selected.busy"
                @ok="dataProvide"
                @hide="dataHide"
            >
                <FormGroupBuilder
                    :fields="fieldsIO"
                    :data="selected.data"
                    :refresh="validationRefresh"
                />
                <b-form-group
                    v-if="selected.data"
                    key="klasse"
                    label-cols-sm="3"
                    label-cols-lg="4"
                    label="Klasse"
                    label-for="klasse"
                    :label-size="size"
                >
                    <b-select
                        id="klasse"
                        :options="klassenSelect"
                        v-model="selected.data.klasse"
                        :size="size"
                    />
                </b-form-group>
                <template slot="modal-ok">
                    <template v-if="!selected.busy">Speichern</template>
                    <template v-else>
                        <Spinner small variant="light" />
                    </template>
                </template>
            </b-modal>

            <b-modal
                id="removeModal"
                ref="removeModal"
                size="sm"
                title="Löschen bestätigen"
                ok-variant="danger"
                centered
                :busy="selected.busy"
                @ok="dataProvide"
                @hide="dataHide"
            >
                Datensatz wirklich löschen?
                <template slot="modal-ok">
                    <template v-if="!selected.busy">Löschen</template>
                    <template v-else>
                        <Spinner small variant="light" />
                    </template>
                </template>
                <template slot="modal-cancel">Abbrechen</template>
            </b-modal>
        </div>
    </MainContainer>
</template>

<script>
import Toaster from "@/mixins/Toaster/Toaster";
import Rights from "@/mixins/Rights/Rights";
import Size from "@/mixins/Size/Size";
import Validation from "@/mixins/Validation/Validation";
import MainContainer from "@/components/MainContainer/MainContainer";
import { ApiFactory } from "@/api/ApiFactory";
import Table from "@/components/Table/Table";
import Spinner from "@/components/Spinner/Spinner";
import FormGroupBuilder from "@/components/FormGroupBuilder/FormGroupBuilder";

const ProbentypApi = ApiFactory.get("probentyp");

export default {
    name: "Probentyp",
    mixins: [Toaster, Size, Rights, Validation],
    components: {
        MainContainer,
        Table,
        Spinner,
        FormGroupBuilder
    },
    data() {
        return {
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "bezeichnung",
                    label: "Bezeichnung",
                    sortable: true
                },
                {
                    key: "kuerzel",
                    label: "Kürzel",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "klasse",
                    label: "Klasse",
                    sortable: false
                },
                {
                    key: "sort",
                    label: "Sortierung",
                    sortable: true,
                    variant: "normal"
                },
                {
                    key: "actions",
                    label: "Aktionen"
                }
            ],
            fieldsIO: {
                id: {
                    key: "id",
                    label: "ID",
                    type: "text",
                    disabled: true,
                    oneWay: true
                },
                bezeichnung: {
                    key: "bezeichnung",
                    label: "Bezeichnung",
                    type: "text",
                    mandatory: true
                },
                kuerzel: {
                    key: "kuerzel",
                    label: "Kürzel",
                    type: "text",
                    mandatory: true
                }
            },
            items: [],
            originalItems: [],
            klassen: [],
            busy: false,
            resorted: false,
            resortedBusy: false,
            selected: {
                data: null,
                action: null,
                title: "",
                busy: false
            }
        };
    },
    created() {
        this.fetch();
        this.fetchKlassen();
    },
    computed: {
        klassenSelect() {
            const select = Object.entries(this.klassen).map(([key, value]) => {
                return {
                    value: key,
                    text: value
                };
            });
            return select;
        }
    },
    watch: {
        resorted: {
            handler(val) {
                var variant = "normal";
                if (val) {
                    variant = "warning";
                }
                const sortField = this.fields.find(item => item.key === "sort");
                if (sortField) {
                    sortField.variant = variant;
                }
            }
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await ProbentypApi.get();

            if (response.ok) {
                const data = response.json.collection;
                this.items = data;
                this.originalItems = data.map(item => {
                    return { ...item };
                });
                this.registerRights(response);
            }
            this.busy = false;
        },
        async fetchKlassen() {
            const response = await ProbentypApi.getKlassen();

            if (response.ok) {
                const klassen = response.json.klassen;
                this.klassen = klassen;
            }
        },
        dataCreate() {
            const newObj = {};
            this.dataSet(newObj, "new", "Probentyp hinzufügen");
            this.$refs["editModal"].show();
        },
        dataSelected(selectedItem) {
            if (!selectedItem) {
                selectedItem = this.items.find(item => {
                    return item.id == index;
                });
            }
            this.dataSet(selectedItem, "edit", "Probentyp bearbeiten");
            this.$refs["editModal"].show();
        },
        dataDelete(selectedItem) {
            if (!selectedItem) {
                selectedItem = this.items.find(item => {
                    return item.id == index;
                });
            }
            this.dataSet(selectedItem, "remove", "Datensatz löschen");
            this.$refs.removeModal.show();
        },
        async dataProvide(evt) {
            evt.preventDefault();

            const selectedItem = this.selected.data;

            if (selectedItem) {
                // TODO: Validation
                this.selected.busy = true;
                var response = null;

                if (this.selected.action === "new") {
                    response = await ProbentypApi.post(selectedItem);
                } else if (this.selected.action === "remove") {
                    response = await ProbentypApi.delete(selectedItem.id);
                } else {
                    response = await ProbentypApi.put(
                        selectedItem.id,
                        selectedItem
                    );
                }

                if (response.ok) {
                    var currentItems = [...this.items];

                    if (this.selected.action === "new") {
                        selectedItem.id = response.json.id;
                        selectedItem.sort = response.json.sort;
                        currentItems.push(selectedItem);
                    } else if (this.selected.action === "remove") {
                        currentItems = currentItems.filter(item => {
                            return item.id !== selectedItem.id;
                        });
                    } else {
                        var changedIndex = currentItems.findIndex(item => {
                            return item.id === selectedItem.id;
                        });
                        currentItems[changedIndex] = selectedItem;
                    }

                    this.items = currentItems;

                    this.dataSet();
                    this.$refs.editModal.hide();
                    this.$refs.removeModal.hide();
                    this.makeToast(
                        "Erfolgreich gespeichert",
                        "Die Änderungen wurden erfolgreich in der Datenbank gespeichert"
                    );
                } else {
                    // TODO: Error handling
                    this.handleValidationData(response, this.fieldsIO);
                    this.selected.busy = false;
                }
            }
        },
        dataHide(evt) {
            if (evt.trigger !== "ok") {
                this.dataSet();
            }
        },
        dataSet(data = null, action = null, title = "") {
            this.selected = {
                data: { ...data },
                action: action,
                title: title,
                busy: false
            };
            this.cleanValidationData(this.fieldsIO);
        },
        sortUp(row) {
            if (row.item) {
                const currItem = row.item;
                const prevItem = this.items.find(
                    item => item.sort === currItem.sort - 1
                );
                this.swapSortItems(currItem, prevItem);
            }
        },
        sortDown(row) {
            if (row.item) {
                const currItem = row.item;
                const nextItem = this.items.find(
                    item => item.sort === currItem.sort + 1
                );
                this.swapSortItems(currItem, nextItem);
            }
        },
        swapSortItems(a, b) {
            if (b) {
                const bSort = b.sort;
                b.sort = a.sort;
                a.sort = bSort;
                if (!this.resorted) {
                    this.resorted = true;
                }
            }
        },
        async sortingProvide() {
            this.resortedBusy = true;
            const response = await ProbentypApi.putSorting(
                this.items.map(item => {
                    return { id: item.id, sort: item.sort };
                })
            );
            if (response.ok) {
                this.makeToast(
                    "Erfolgreich gespeichert",
                    "Die Sortierung wurde erfolgreich in der Datenbank gespeichert"
                );
                this.resorted = false;
            } else {
                this.makeToast(
                    "Speichern fehlgeschlagen",
                    "Das Speichern der Änderungen ist fehlgeschlagen",
                    "danger"
                );
            }
            this.resortedBusy = false;
        },
        async sortingAbort() {
            this.items = [...this.originalItems];
            this.resorted = false;
        }
    }
};
</script>
